// src/CoinSystem.js
export const COIN_RATES = {
  STARTING_COINS: 20,
  EARN_PER_REVIEW: 10,
  COST_PER_REVIEW: 10,
  MIN_COINS_TO_RECEIVE: 10
};

// Check if user has enough coins to receive reviews
export const canReceiveReview = (user) => {
  return user.coins >= COIN_RATES.COST_PER_REVIEW;
};

// Get coin balance display
export const getCoinStatus = (user) => {
  const canReceive = canReceiveReview(user);
  return {
    balance: user.coins,
    canReceive,
    message: canReceive 
      ? `${user.coins} coins available` 
      : `Need ${COIN_RATES.MIN_COINS_TO_RECEIVE} coins to receive reviews`
  };
};


// ============================================
// src/CoinSystem.js
// Coin bundles are priced in USD (display + Flutterwave charge).
// Paystack charges the Naira equivalent (priceNgn), fixed at $1 = ₦1,300.
// ============================================

export const COIN_PRICE_NGN = 200;        // base price per coin in Naira
export const COINS_PER_REVIEW = 10;        // 1 review costs/earns 10 coins
export const LOW_COIN_THRESHOLD = 10;      // books hide below this
export const USD_TO_NGN = 1300;

export const COIN_BUNDLES = [
  {
    id: 'single',
    coins: 10,
    reviews: 1,
    priceUsd: 1.99,
    priceNgn: 2600,
    popular: false
  },
  {
    id: 'starter',
    coins: 30,
    reviews: 3,
    priceUsd: 5.97,
    priceNgn: 7800,
    popular: false
  },
  {
    id: 'popular',
    coins: 50,
    reviews: 5,
    priceUsd: 9.95,
    priceNgn: 12900,
    popular: true
  },
  {
    id: 'bulk',
    coins: 100,
    reviews: 10,
    priceUsd: 19.90,
    priceNgn: 25900,
    popular: false
  },
  {
    id: 'mega',
    coins: 1000,
    reviews: 100,
    priceUsd: 199.00,
    priceNgn: 258700,
    popular: false
  },
];

export const isLowOnCoins = (user) => {
  return (user?.coins || 0) < LOW_COIN_THRESHOLD;
};